<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">Customers</h1>
      </template>
      <template #actions>
        <page-header-action tag="a" href="#" @click.prevent="sendToCreateView">
          Create Customer
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="loading-overlay" v-if="loading"></div>
          <table class="table carpenter">
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email Address</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr v-bind:key="index" v-for="(customer, index) in customers">
                <td v-text="customer.first_name"></td>
                <td v-text="customer.last_name"></td>
                <td v-text="customer.email"></td>
                <td>
                  <router-link
                    :to="`/customers/${customer.identifier}`"
                    class="btn btn-primary btn-sm with-icon"
                    >Edit</router-link
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  components: {
    PageHeader,
    PageHeaderAction
  },

  data() {
    return {
      customers: [],
      loading: true
    };
  },

  mounted() {
    this.findCustomers();
  },

  methods: {
    findCustomers() {
      this.loading = true;

      window.Ajax.get('/customers')
        .then(response => {
          this.loading = false;
          this.customers = response.data;
        })
        .catch(err => {});
    },

    sendToCreateView() {
      this.route('/customers/create');
    }
  }
};
</script>
